import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function HomeIcon() {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      width='29'
      height='29'
      viewBox='0 0 29 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.3159 3.90428C14.1173 3.18425 15.3326 3.18425 16.134 3.90428L23.8646 10.8499C24.3097 11.2498 24.5639 11.8199 24.5639 12.4182V22.3333C24.5639 23.4977 23.6199 24.4416 22.4555 24.4416H18.9416C17.7772 24.4416 16.8333 23.4977 16.8333 22.3333V17.4138C16.8333 17.0257 16.5186 16.711 16.1305 16.711H13.3194C12.9312 16.711 12.6166 17.0257 12.6166 17.4138V22.3333C12.6166 23.4977 11.6726 24.4416 10.5082 24.4416H6.99433C5.82992 24.4416 4.88599 23.4977 4.88599 22.3333V12.4182C4.88599 11.8199 5.14019 11.2498 5.58526 10.8499L13.3159 3.90428ZM15.1946 4.94983C14.9275 4.70982 14.5224 4.70982 14.2552 4.94983L6.52464 11.8955C6.37629 12.0288 6.29155 12.2188 6.29155 12.4182V22.3333C6.29155 22.7214 6.6062 23.0361 6.99433 23.0361H10.5082C10.8964 23.0361 11.211 22.7214 11.211 22.3333V17.4138C11.211 16.2494 12.155 15.3055 13.3194 15.3055H16.1305C17.2949 15.3055 18.2388 16.2494 18.2388 17.4138V22.3333C18.2388 22.7214 18.5535 23.0361 18.9416 23.0361H22.4555C22.8437 23.0361 23.1583 22.7214 23.1583 22.3333V12.4182C23.1583 12.2188 23.0736 12.0288 22.9252 11.8955L15.1946 4.94983Z'
        fill={isDark ? 'white' : '#335173'}
      />
    </svg>
  )
}
